
export default {
  profileSelector: {
    'activeProfile': 'Activo'
  }
}
